import React, { useState, useContext } from "react";
import { Button, Row, Col } from "react-bootstrap";
import UserSelector from "utils/UserSelector";
import CreateNewUser from "./CreateNewUser";
import { SettingsContext } from './AccountSettingsButton'

export default function ClientUsers(props) {


  const context = useContext(SettingsContext);
  // Users selected in user selector as client users
  const [selectedUsers, setSelectedUsers] = useState(props.client_account.client_users ? props.client_account.client_users : [])
  // All client users in the database with relevant data
  const [clientUsers, setClientUsers] = useState(props.client_users ? props.client_users : {})
  // New users that will need to be created on client config save
  const newUsers = context.newUsers
  const setNewUsers = context.setNewUsers
  


  const addNewUser = (user) => {
    let newClientUsers = {...clientUsers}
    newClientUsers[user.email] = {
      avatar: false,
      avatar_big: false,
      name: user.firstName + " " + user.lastName,
      job_title: null,
      department: "no_department"
    }
    setClientUsers(newClientUsers)
    setSelectedUsers([...selectedUsers, user.email])
    setNewUsers([...newUsers, {
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      accountAccessIds: user.accountAccessIds
    }])
  }

  const hiddenFields = newUsers.map((user, index) => (
    <React.Fragment key={index}>
      <input hidden name={`[new_users][${index}][email]`} value={user.email} readOnly />
      <input hidden name={`[new_users][${index}][first_name]`} value={user.firstName} readOnly />
      <input hidden name={`[new_users][${index}][last_name]`} value={user.lastName} readOnly />
      {user.accountAccessIds.map((id) => (
        <input key={id} hidden name={`[new_users][${index}][account_access_ids][]`} value={id} readOnly />
      ))}
    </React.Fragment>
  ))

  return (
    <>
      <Row className="px-4 pt-4 pb-0">
        <Col className="mb-3">
          <h3 className="section-header">Client Users</h3>
        </Col>
        <Col md={"auto"} className="text-center text-lg-left">
          <CreateNewUser clients={props.clients} addNewUser={addNewUser} selectedAccountId={props.client_account.id}/>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="px-4 px-lg-5" style={{ paddingBottom: "15px"}}>
            <p className="f16 visby-medium primary mt-3">Internal Datapulse users</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="">
          <div className="px-4 px-lg-5">
            {hiddenFields}
            <UserSelector
              modalHeader={`${props.company_name} - Select Client Users`}
              users={clientUsers}
              defaultValue={selectedUsers}
              fieldsForArray={["client_users"]} 
              bigAvatars
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
